export const getObjectIdConvertedTimestamp = (id: string) => {
  const timestamp = id.toString().substring(0, 8);

  return new Date(parseInt(timestamp, 16) * 1000);
};
